import React from 'react';
import './App.css';
// You have to import image to use it
import Honkai from './components/Honkai';

import { Container } from '@mui/material';

const App = () => {
  return (
    <Container>
      <Honkai />
    </Container>
  );
}

export default App;
